import type { YardiPaginationProps } from '../types'

/**
 * Matches InviteeList PaginationControls styling (first/prev/numbered/next/last).
 */
export function YardiPagination({ pageOptions, onPageChange, placement }: YardiPaginationProps) {
  const currentPage = pageOptions.current || 1
  const totalPages = pageOptions.last || 1

  if (totalPages < 1) return null

  const btnNav =
    'min-w-[32px] h-8 px-2 shrink-0 flex items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-500 hover:bg-slate-50 hover:text-slate-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all'

  const p = placement
  return (
    <div
      data-testid={`yardi-invite-pagination-${p}`}
      className="flex w-full min-w-0 flex-wrap items-center justify-center gap-1 sm:w-auto sm:justify-end sm:gap-1.5"
    >
      <button
        type="button"
        data-testid={`yardi-invite-pagination-${p}-first`}
        className={btnNav}
        onClick={() => onPageChange(1)}
        disabled={currentPage === 1}
        title="First"
      >
        &laquo;
      </button>
      <button
        type="button"
        data-testid={`yardi-invite-pagination-${p}-previous`}
        className={btnNav}
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        title="Previous"
      >
        &lsaquo;
      </button>
      {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
        let pageNum: number
        if (totalPages <= 5) {
          pageNum = i + 1
        } else if (currentPage <= 3) {
          pageNum = i + 1
        } else if (currentPage >= totalPages - 2) {
          pageNum = totalPages - 4 + i
        } else {
          pageNum = currentPage - 2 + i
        }
        const isActive = currentPage === pageNum
        return (
          <button
            key={pageNum}
            type="button"
            data-testid={`yardi-invite-pagination-${p}-page-${pageNum}`}
            className={`min-w-[32px] h-8 px-2 shrink-0 flex items-center justify-center rounded-lg text-sm font-medium transition-all border ${
              isActive
                ? 'border-button bg-button text-white shadow-md shadow-slate-300/30'
                : 'bg-white text-slate-600 border-slate-200 hover:bg-slate-50 hover:border-slate-300'
            }`}
            onClick={() => onPageChange(pageNum)}
          >
            {pageNum}
          </button>
        )
      })}
      <button
        type="button"
        data-testid={`yardi-invite-pagination-${p}-next`}
        className={btnNav}
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        title="Next"
      >
        &rsaquo;
      </button>
      <button
        type="button"
        data-testid={`yardi-invite-pagination-${p}-last`}
        className={btnNav}
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage === totalPages}
        title="Last"
      >
        &raquo;
      </button>
    </div>
  )
}
